import React from 'react';
import { LinkButton } from 'fronton-react';
import { useSelector } from 'react-redux';
import { createGetExperiment } from 'features/page-model';
import { BRAND_CHARACTERISTICS_KEY, HIDE_BRANDS_INTERNAL_ID } from 'common/constants';

import { Group, Description, Value } from './list.style';
import { getBrandLink } from 'utils/get-brand-link';

export const DATA_QA_CHARACTERISTICS_LIST_ITEM = 'characteristics-list-item';

type Props = {
  attribute: string;
  description: string;
  value: string;
  href?: string;
};

export const ListItem: React.FC<Props> = ({ attribute, value, description, href }) => {
  const isHideBrandsExperimentActive = !!useSelector(createGetExperiment(HIDE_BRANDS_INTERNAL_ID));

  return (
    <Group data-qa={DATA_QA_CHARACTERISTICS_LIST_ITEM}>
      <Description>{description}</Description>
      <Value>{renderDefinition(isHideBrandsExperimentActive, attribute, value, href)}</Value>
    </Group>
  );
};

export function renderDefinition(isHideBrandsExperimentActive: boolean, key = '', text = '', href?: string) {
  const isBrand = key === BRAND_CHARACTERISTICS_KEY;

  if (isBrand && isHideBrandsExperimentActive) {
    return <Value data-qa="brand-name-no-link">{text}</Value>;
  }

  const linkHref = isBrand ? getBrandLink(text) : href;

  if (linkHref) {
    return (
      <LinkButton target="_blank" rel="noopener noreferrer" href={linkHref} variant="underline">
        {text}
      </LinkButton>
    );
  }

  return text;
}
